import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Button,
  Platform,
  Modal,
  ActivityIndicator,
  Dimensions,
  PixelRatio,
  Linking,
} from "react-native";
import React, { useEffect, useState } from "react";
import Icon from "react-native-vector-icons/Ionicons";
import { TextInput } from "react-native";
import Colours from "../../utils/Colours";
import { useNavigation } from "@react-navigation/native";
import * as ImagePicker from "expo-image-picker";
import axios from "../../api/axios";
import { Picker } from "@react-native-picker/picker";
import CalenderSignUpScreenModal from "./CalenderSignUpScreenModal";
import CalenderIcon from "../../icons/CalenderIcon";
import BackArrow from "../../icons/BackArrow";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import * as ImageManipulator from "expo-image-manipulator";
import * as FileSystem from "expo-file-system";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { Image } from "expo-image";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const dpr = Math.round(PixelRatio.get() || 1);
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const MAX_IMAGE_SIZE_MB = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicThumbnailWidth = Math.round(width * 0.15);
const dynamicThumbnailHeight = Math.round(height * 0.15);

const BodySignUpScreen = () => {
  const [image, setImage] = useState(null);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [gender, setGender] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [isFirstNameFocused, setIsFirstNameFocused] = useState(false);
  const [isLastNameFocused, setIsLastNameFocused] = useState(false);
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [isPhoneNumberFocused, setIsPhoneNumberFocused] = useState(false);
  const [isGenderFocused, setIsGenderFocused] = useState(false);
  const [isBirthdayFocused, setIsBirthdayFocused] = useState(false);
  const [isProfilePhotoFocused, setIsProfilePhotoFocused] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // const [passwordError, setPasswordError] = useState('')
  const [suggestions, setSuggestions] = useState([]);
  const [strength, setStrength] = useState("");
  const [validEmailFormat, setValidEmailFormat] = useState(false);
  const [validPhoneNumber, setValidPhoneNumber] = useState(false);
  const [checkEmailExists, setCheckEmailExits] = useState(false);

  const [retryCount, setRetryCount] = useState(0);
  const [imageKey, setImageKey] = useState(0);

  const [showDateModal2, setShowDateModal2] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedBirthDate, setSelectedBirthDate] = useState({});
  const [isDateSelected, setIsDataSelected] = useState(true);
  const [userDataObj, setUserDataObj] = useState({});
  const [showUsernameDisplaynameScreen, setShowUsernameDisplaynameScreen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);

  const navigate = useNavigation();

  useEffect(() => {
    //console.log('selectedBirthDate1', selectedBirthDate)
  }, [selectedBirthDate]);

  // useEffect(() => {
  //     if (Object.keys(userDataObj).length > 0) {
  //         submitUser_to_db();
  //     }
  // }, [userDataObj]);

  //handleFormInputs
  const handleFirstname = (text) => {
    setFirstname(text);
  };
  const handleLastname = (text) => {
    setLastname(text);
  };
  // const handleEmail = (text) => {
  //     //console.log('Email', text)
  //     //console.log('EmailLoweer', text.toLowerCase())
  //     setEmail(text.toLowerCase())
  //     setValidEmailFormat(validateEmail(text))
  //     // setCheckEmailExits(checkIfemailExists(text))
  // }

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    //console.log('topHeader', targetHeight)
    //console.log('topHeaderW', targetWidth)

    // The 'transformations' string includes the optimization flags
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    // Inject the transformations into the URL
    return originalUrl.replace(/upload\//, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      //console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      //console.error('Image failed to load after maximum retries.');
    }
  };

  const newUserProfileThumbnailUrl = getOptimizedCloudinaryUrl(
    image,
    dynamicThumbnailWidth,
    dynamicThumbnailHeight,
  );

  //console.log('newUserProfileThumbnailUrl', newUserProfileThumbnailUrl)
  //console.log('image', image)

  const handleEmail = (text) => {
    if (typeof text !== "string") {
      //console.warn('Invalid email input:', text);
      return;
    }

    const normalizedEmail = text.trim().toLowerCase();

    //console.log('Email:', text);
    //console.log('Normalized Email:', normalizedEmail);

    setEmail(normalizedEmail);
    setValidEmailFormat(validateEmail(normalizedEmail));
  };

  const handlePassword = (text) => {
    setPassword(text);
    //console.log('PASSWORDTXT', text)
    //validatePassword(text);
    validatePassword_soft(text);
  };
  const handlePhonenumber = (text) => {
    setPhonenumber(text);
    setValidPhoneNumber(validateNigerianPhoneNumber(text));
  };
  const handleGender = (text) => {
    setGender(text);
  };

  const handleCalenderDateModal = () => {
    setShowDateModal2(true);
  };

  const validatePassword_soft = (input) => {
    let newSuggestions = [];
    if (input.length < 8) {
      newSuggestions.push(" Password should be at least 8 characters long");
    }
    setSuggestions(newSuggestions);
  };

  const validatePassword = (input) => {
    let newSuggestions = [];
    if (input.length < 8) {
      newSuggestions.push(" Password should be at least 8 characters long");
    }
    if (!/\d/.test(input)) {
      newSuggestions.push(" Add at least one number");
    }

    if (!/[A-Z]/.test(input) || !/[a-z]/.test(input)) {
      newSuggestions.push(" Include both upper and lower case letters");
    }

    if (!/[^A-Za-z0-9]/.test(input)) {
      newSuggestions.push(" Include at least one special character");
    }

    setSuggestions(newSuggestions);

    // Determine password strength based on suggestions
    if (newSuggestions.length === 0) {
      setStrength("Very Strong");
      //console.log('Very Strong')
    } else if (newSuggestions.length <= 1) {
      setStrength("Strong");
      //console.log('Strong')
    } else if (newSuggestions.length <= 2) {
      setStrength("Moderate");
      //console.log('Moderate')
    } else if (newSuggestions.length <= 3) {
      setStrength("Weak");
      //console.log('Weak')
    } else {
      setStrength("Too Weak");
      //console.log('Too Weak')
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const checkIfemailExists = async (email) => {
    //console.log('Email', email)
    try {
      setIsLoading2(true);
      const response = await axios.get(`/checkEmail/checkEmail/${email}`);
      if (response.status === 200 || response.status === 201) {
        if (response.data.exists) {
          //console.log('response.status.exists', response.data.exists)
          return true;
        } else {
          return false;
        }
      } else {
        setErrorMessage("Server error");
        setIsErrorCompVisible(true);
        return "Server error";
      }
    } catch (error) {
      //console.log('SERVERErrpr');
      if (error.response) {
        //console.log('RESPONSE SERVERErrpr');
        //console.log('RESPONSE ERROR:', error.response.data);
        //console.log('RESPONSE ERROR MSG:', error.response.data.message);
        setErrorMessage(error.response.data.message);
        setIsErrorCompVisible(true);
      } else {
        //console.log('NetWorkError');
        //console.log('NETWORK ERROR', error.message);
        setErrorMessage("Network error: " + error.message);
        setIsErrorCompVisible(true);
      }

      // setErrorMessage(error.response.data.message)
      // setIsErrorCompVisible(true)
      //console.log('Signup Error Email', error)
      //console.log('Signup error2 Email', error.message)
      //console.log('Signup Error Email3', error.response.data)
      return "Server error";
    } finally {
      setIsLoading2(false);
    }
  };

  const checkIfPhoneExists = async (phonenumber) => {
    //console.log('Phone', phonenumber)
    try {
      setIsLoading2(true);
      const response = await axios.get(`/phoneExists/phoneExists/${phonenumber}`);
      if (response.status === 200 || response.status === 201) {
        if (response.data.exists) {
          //console.log('response.status.exists', response.data.exists)
          return true;
        } else {
          return false;
        }
      } else {
        setErrorMessage("Server error");
        setIsErrorCompVisible(true);
        return "Server error";
      }
    } catch (error) {
      //console.log('AXIOS ERROR', error); // Log the whole error
      //console.log('AXIOS ERRORXX'); // Log the whole error
      if (error.response) {
        //console.log('RESPONSE ERROR:', error.response.data);
        //console.log('RESPONSE ERROR MSG:', error.response.data.message);
        setErrorMessage(error.response.data.message);
        setIsErrorCompVisible(true);
      } else {
        //console.log('AXIOS NETWORK ERR'); // Log the whole error
        //console.log('NETWORK ERROR', error.message);
        setErrorMessage("Network error: " + error.message);
        setIsErrorCompVisible(true);
      }
      //console.log('Signup Error Phone', error)
      //console.log('Signup error2 Phone', error.message)
      //console.log('Signup error3 Phone', error.response.data)
      // setErrorMessage(error.response.data.message)
      // setIsErrorCompVisible(true)
      return "Server error";
    } finally {
      setIsLoading2(false);
    }
  };

  const validateNigerianPhoneNumber = (phoneNumber) => {
    //const nigerianPhoneRegex = /^(?:\+234|0)(70[1-9]|80[1-9]|81[0-9]|90[1-9]|91[0-9])\d{6}$/
    const nigerianPhoneRegex = /^(?:\+234|0)(7[01]|8[01]|9[01])\d{8}$/;
    return nigerianPhoneRegex.test(phoneNumber);
  };

  const saveSetBirthDate = () => {
    if (selectedDate === undefined) {
      alert("Please enter a valid birth date");
    } else {
      const birthDateObj = { selectedDate };
      //console.log('birthDateObj:', birthDateObj)
      setSelectedBirthDate(birthDateObj);
      setShowDateModal2(false);
    }
  };

  const handleSignUpButton = () => {
    formValidation();
    //   setShowUsernameDisplaynameScreen(true)
  };

  const formValidation = async () => {
    const emailCheckResult = await checkIfemailExists(email);
    const phoneCheckResult = await checkIfPhoneExists(phonenumber);
    //Validating all forms
    if (firstname === "") {
      setIsFirstNameFocused(true);
    } else if (lastname === "") {
      setIsLastNameFocused(true);
    } else if (email === "") {
      setIsEmailFocused(true);
    } else if (validEmailFormat === false) {
      setErrorMessage("Wrong email address");
      setIsErrorCompVisible(true);
    } else if (emailCheckResult === true) {
      setErrorMessage("Email already been registered with us");
      setIsErrorCompVisible(true);
    } else if (emailCheckResult === "Server error") {
      setErrorMessage("Server error");
      setIsErrorCompVisible(true);
    } else if (phoneCheckResult === true) {
      setErrorMessage("Phonenumber already been registered with us");
      setIsErrorCompVisible(true);
    } else if (phoneCheckResult === "Server error") {
      setErrorMessage("Server error");
      setIsErrorCompVisible(true);
    } else if (validPhoneNumber === false) {
      setErrorMessage("Enter a valid phone number");
      setIsErrorCompVisible(true);
    } else if (password === "") {
      setIsPasswordFocused(true);
      // } else if (strength === "") {
      //   setErrorMessage("Set a strong password");
      //   setIsErrorCompVisible(true);

      // } else if (strength !== "Very Strong") {
      //   setErrorMessage("Set a strong password");
      //   setIsErrorCompVisible(true);
    } else if (phonenumber === "") {
      setIsPhoneNumberFocused(true);
    } else if (gender === "") {
      setIsGenderFocused(true);
    } else if (Object.keys(selectedBirthDate).length === 0) {
      setIsBirthdayFocused(true);
    } else if (image === null) {
      setErrorMessage("Please select a profile picture");
      setIsProfilePhotoFocused(true);
      setIsErrorCompVisible(true);
    } else {
      //console.log("They all cool except Picture for now")
      const birthday = selectedBirthDate.selectedDate.toDateString();
      // const userObj = { firstname, lastname, email, password, phonenumber, gender, birthday, image }
      const userDataObj = {
        firstname,
        lastname,
        email,
        password,
        phonenumber,
        gender,
        birthday,
        image,
      };

      //setUserDataObj(userObj)
      //  //console.log("userObj", userObj)
      navigate.push("username_displayname", { userDataObj });
    }
  };

  const prepareImageForUpload = async (imageUri) => {
    try {
      const fileInfo = await FileSystem.getInfoAsync(imageUri);

      if (fileInfo.size && fileInfo.size <= MAX_IMAGE_SIZE_BYTES) {
        // Already under 1MB, return as-is
        //console.log(`Image is already ${Math.round(fileInfo.size / 1024)} KB`);
        return imageUri;
      }

      //console.log(`Image too large: ${Math.round(fileInfo.size / 1024)} KB, compressing...`);
      let compressRatio = 0.9;
      let compressed = null;

      while (compressRatio > 0.1) {
        compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
          compress: compressRatio,
          format: ImageManipulator.SaveFormat.JPEG,
        });

        const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);

        if (compressedInfo.size && compressedInfo.size <= MAX_IMAGE_SIZE_BYTES) {
          console.log(`Compressed to ${Math.round(compressedInfo.size / 1024)} KB`);
          return compressed.uri;
        }

        compressRatio -= 0.1;
      }

      // console.warn('Could not get image under 1MB. Returning best attempt.');
      return compressed ? compressed.uri : imageUri;
    } catch (error) {
      // console.error('Image compression failed:', error);
      return imageUri; // fallback to original
    }
  };

  const pickImageFromPhone = async () => {
    try {
      setIsLoading(true);

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
        aspect: [4, 4],
        quality: 1,
        //   selectionLimit: 4 - images.length
      });

      if (!result.canceled) {
        //console.log('result:', result)
        //setImages([...images, result.assets[0].uri]);
        imageUri = result.assets[0].uri;

        // Check file size using FileSystem
        const fileInfo = await FileSystem.getInfoAsync(imageUri);
        const fileSizeInMB = fileInfo.size / (1024 * 1024); // convert bytes to MB

        //console.log(`Image size: ${fileSizeInMB.toFixed(2)} MB`);

        if (fileSizeInMB > 65) {
          setErrorMessage(
            `Image too large: The selected image is ${fileSizeInMB.toFixed(
              2,
            )} MB. Please choose one below.`,
          );
          setIsErrorCompVisible(true);
          return; // stop further action
        }

        const processedImageUri = await prepareImageForUpload(imageUri);
        // const processedImageUri = imageUri // We will not be compressing images again

        //console.log('processedImageUri', processedImageUri)

        setImage(processedImageUri);
      }
    } catch (error) {
      //console.error('Error picking image:', error);
    } finally {
      setIsLoading(false);
    }
  };

  //custom styled picker so that it can be easily customized.
  const StyledPickerItem = ({ label, value, style }) => (
    <View style={style}>
      <Picker.Item label={label} value={value} />
    </View>
  );

  return (
    <View style={styles.container}>
      {/* <TouchableOpacity
                onPress={() => navigate.goBack()} // Use an arrow function
            >
                <BackArrow color={Colours.DARKGRAY} />
            </TouchableOpacity> */}
      <Text style={styles.title}>Get Started</Text>

      {/* Profile Photo */}
      <View style={styles.profilePhotoContainer}>
        <TouchableOpacity
          onPress={pickImageFromPhone}
          onFocus={() => setIsProfilePhotoFocused(true)}
          onBlur={() => {
            setIsProfilePhotoFocused(false);
          }}
        >
          {isLoading ? (
            <ActivityIndicator size="large" color={Colours.PRIMARY} />
          ) : image ? (
            <Image
              source={{ uri: image }}
              style={[styles.userImage, { backgroundColor: "#d6d4d4ff" }]}
              contentFit="cover"
              cachePolicy="disk"
              onError={handleImageError}
            />
          ) : (
            <Image
              source={require("../../../assets/profile_image_holder.jpg")}
              style={[styles.userImage, isProfilePhotoFocused && styles.focusedBorder]}
            />
          )}
        </TouchableOpacity>
        <Text style={styles.addPhotoText}>ADD YOUR DP</Text>
      </View>

      {/* Form */}
      <View style={styles.formContainer}>
        {/* First & Last Name */}
        <View style={styles.row}>
          <View style={styles.inputBox}>
            <Text style={styles.label}>FIRST NAME</Text>
            <AppTextInput
              style={[styles.shortInput, isFirstNameFocused && styles.focusedBorder]}
              placeholder="First name"
              fontSize={15}
              onFocus={() => setIsFirstNameFocused(true)}
              onBlur={() => setIsFirstNameFocused(false)}
              onChangeText={handleFirstname}
            />
          </View>
          <View style={styles.inputBox}>
            <Text style={styles.label}>LAST NAME</Text>
            <AppTextInput
              style={[styles.shortInput, isLastNameFocused && styles.focusedBorder]}
              placeholder="Last name"
              fontSize={15}
              onFocus={() => setIsLastNameFocused(true)}
              onBlur={() => setIsLastNameFocused(false)}
              onChangeText={handleLastname}
            />
          </View>
        </View>

        {/* Email */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>EMAIL</Text>
          <AppTextInput
            style={[styles.input, isEmailFocused && styles.focusedBorder]}
            placeholder="Email"
            fontSize={15}
            keyboardType="email-address"
            onFocus={() => setIsEmailFocused(true)}
            onBlur={() => setIsEmailFocused(false)}
            onChangeText={handleEmail}
          />
        </View>

        {suggestions.length > 0 && (
          <View style={styles.passwordErrorMsg}>
            <Text style={styles.passwordMsgTxt}>
              {suggestions.map((suggestion, index) => (
                <Text key={index}>
                  {suggestion}
                  {/* {'\n'} */}
                </Text>
              ))}
            </Text>
          </View>
        )}
        {/* Strength Meter */}
        {strength.length > 0 && (
          <View style={styles.strengthMeter}>
            <View
              style={{
                width: `${
                  strength === "Very Strong"
                    ? 100
                    : strength === "Strong"
                      ? 75
                      : strength === "Moderate"
                        ? 50
                        : strength === "Weak"
                          ? 25
                          : 0
                }%`,
                height: 20,
                backgroundColor:
                  strength === "Too Weak"
                    ? "red"
                    : strength === "Weak"
                      ? "orange"
                      : strength === "Moderate"
                        ? "yellow"
                        : strength === "Strong"
                          ? "green"
                          : "limegreen",
              }}
            ></View>
          </View>
        )}

        {/* Password */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>PASSWORD</Text>
          <AppTextInput
            style={[styles.input, isPasswordFocused && styles.focusedBorder]}
            placeholder="Password"
            fontSize={15}
            secureTextEntry={!showPassword}
            onFocus={() => setIsPasswordFocused(true)}
            onBlur={() => {
              setIsPasswordFocused(false);
              // setPasswordError(false)
            }}
            onChangeText={handlePassword}
            // rightButton={<Icon name={showPassword ? 'eye-off' : 'eye'} onPress={() => setShowPassword(!showPassword)} />}
          />
          <TouchableOpacity onPress={() => setShowPassword(!showPassword)}>
            <Icon
              name={showPassword ? "eye-off-outline" : "eye-outline"}
              size={dynamicSize(22)}
              color={Colours.PRIMARY_LIGHT}
              style={{ marginLeft: dynamicSpacing(10), marginTop: dynamicSize(10) }}
            />
          </TouchableOpacity>
        </View>

        {/* Phone Number */}
        <View style={styles.inputContainer}>
          <Text style={styles.label}>PHONE NUMBER</Text>
          <AppTextInput
            style={[styles.input, isPhoneNumberFocused && styles.focusedBorder]}
            placeholder="Phone-number"
            keyboardType="phone-pad"
            fontSize={15}
            onFocus={() => setIsPhoneNumberFocused(true)}
            onBlur={() => setIsPhoneNumberFocused(false)}
            onChangeText={handlePhonenumber}
          />
        </View>

        {/* Gender & Birthday */}
        <View style={styles.row}>
          {/* Gender */}
          <View style={styles.inputBox}>
            <Text style={styles.label}>GENDER</Text>
            <View style={[styles.shortInput, isGenderFocused && styles.focusedBorder]}>
              <Picker
                selectedValue={gender}
                onValueChange={handleGender}
                onFocus={() => setIsGenderFocused(true)}
                onBlur={() => setIsGenderFocused(false)}
              >
                <StyledPickerItem label="Gender" value={"Gender"} />
                {/* <Picker.Item style={{ fontFamily: 'Sen-Regular', color: Colours.PRIMARY }} label='Birth-Day Pull ' value={'Birth Days'} /> */}
                <StyledPickerItem
                  style={{ fontFamily: "Sen-Regular", color: Colours.PRIMARY }}
                  label="MALE"
                  value={"MALE"}
                />
                <StyledPickerItem
                  style={{ fontFamily: "Sen-Regular", color: Colours.PRIMARY }}
                  label="FEMALE"
                  value={"FEMALE"}
                />
              </Picker>
            </View>
          </View>

          {/* Birthday */}
          <View style={styles.inputBox}>
            <Text style={styles.label}>BIRTHDAY</Text>
            <TouchableOpacity
              style={[styles.shortInput, isBirthdayFocused && styles.focusedBorder]}
              onFocus={() => setIsBirthdayFocused(true)}
              onBlur={() => setIsBirthdayFocused(false)}
              onPress={handleCalenderDateModal}
            >
              {Object.keys(selectedBirthDate).length === 0 ? (
                isDateSelected && (
                  <View style={styles.birthdayBox}>
                    <Text style={styles.birthDayTxt}>Birthday</Text>

                    <CalenderIcon
                      color={Colours.DARKLIGHTGRAY}
                      width={dynamicSize(25)}
                      height={dynamicSize(25)}
                    />
                  </View>
                )
              ) : (
                <View style={styles.birthdayBox}>
                  <Text style={styles.birthDayEnteredTxt}>
                    {selectedBirthDate.selectedDate.toDateString()}
                  </Text>

                  <CalenderIcon
                    color={Colours.DARKLIGHTGRAY}
                    width={dynamicSize(25)}
                    height={dynamicSize(25)}
                  />
                </View>
              )}
            </TouchableOpacity>
          </View>
        </View>

        {/* Sign Up Button */}
        <TouchableOpacity style={styles.signUpButton} onPress={handleSignUpButton}>
          {isLoading2 ? (
            <ActivityIndicator color={"white"} size={"small"} />
          ) : (
            <Text style={styles.signUpText}>SIGN UP</Text>
          )}
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.logInView}
          onPress={() => Linking.openURL("https://getmeeza.com/privacypolicy")}
        >
          <Text style={styles.loginText}>
            By signing up to create an account, you are accepting our{" "}
            <Text style={styles.link}>terms of service and privacy policy</Text>
          </Text>
        </TouchableOpacity>

        {/* Already have an account */}
        <TouchableOpacity style={styles.logInView} onPress={() => navigate.push("log_in")}>
          <Text style={styles.loginText}>
            Already have an account?
            <Text style={styles.loginLink}> Proceed to Login</Text>
          </Text>
        </TouchableOpacity>
      </View>

      {/* Birthday Modal */}
      <Modal animationType="slide" visible={showDateModal2}>
        <CalenderSignUpScreenModal
          hidePullModal={() => setShowDateModal2(false)}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          saveSetBirthDate={saveSetBirthDate}
          mode="dob"
        />
      </Modal>

      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </View>
  );
};

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     padding: width * 0.04,
//     paddingTop: height * 0.05,
//     backgroundColor: "white",
//   },
//   title: {
//     // fontSize: width * 0.07,
//     fontSize: dynamicFontSize(30),
//     color: Colours.DARKGRAY,
//     fontFamily: "Sen-Bold",
//     textAlign: "center",
//     marginTop: height * 0.01,
//   },
//   profilePhotoContainer: {
//     alignItems: "center",
//     marginBottom: height * 0.02,
//   },
//   link: {
//     //color: '#007AFF',
//     textDecorationLine: "underline",
//     color: Colours.PRIMARY_LIGHT,
//     textAlign: "center",
//     // fontSize: width * 0.04,
//     // fontSize: dynamicFontSize(16),
//     // marginTop: height * 0.04,
//     fontFamily: "Sen-Bold",
//   },
//   userImage: {
//     width: width * 0.15,
//     height: width * 0.15,
//     borderRadius: 99,
//     borderWidth: 1.5,
//     borderColor: Colours.DARKLIGHTGRAY,
//     marginTop: height * 0.015,
//   },
//   addPhotoText: {
//     color: Colours.PRIMARY,
//     // fontSize: width * 0.035,
//     fontSize: dynamicFontSize(15),
//     fontFamily: "Sen-Bold",
//   },
//   formContainer: {
//     marginTop: height * 0.02,
//   },
//   focusedBorder: {
//     borderColor: Colours.PRIMARY,
//   },
//   row: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginBottom: height * 0.015,
//   },
//   inputBox: {
//     width: "48%",
//   },
//   passwordErrorMsg: {
//     padding: dynamicSize(10),
//     marginTop: dynamicSize(10),
//     borderRadius: dynamicSize(10),
//     backgroundColor: Colours.PRIMARY_LIGHTER,
//   },
//   passwordMsgTxt: {
//     fontSize: dynamicFontSize(12),
//     fontFamily: "Sen-Regular",
//     color: Colours.PRIMARY,
//   },
//   inputContainer: {
//     marginBottom: height * 0.015,
//   },
//   label: {
//     color: Colours.DARKGRAY,
//     // fontSize: width * 0.03,
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Regular",
//   },
//   birthDayTxt: {
//     color: Colours.DARKLIGHTGRAY,
//     // fontSize: width * 0.03,
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Regular",
//   },
//   birthDayEnteredTxt: {
//     color: Colours.PRIMARY,
//     fontSize: width * 0.03,
//     fontFamily: "Sen-Regular",
//   },
//   input: {
//     height: height * 0.06,
//     borderWidth: 1.5,
//     borderColor: Colours.DARKLIGHTGRAY,
//     borderRadius: 7,
//     fontFamily: "Sen-Regular",
//     paddingHorizontal: width * 0.03,
//   },
//   birthdayBox: {
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//     paddingHorizontal: width * 0.01,
//     paddingVertical: width * 0.02,
//   },
//   shortInput: {
//     height: height * 0.06,
//     width: "100%",
//     borderWidth: 1.5,
//     borderColor: Colours.DARKLIGHTGRAY,
//     borderRadius: 7,
//     fontFamily: "Sen-Regular",
//     paddingHorizontal: width * 0.03,
//   },
//   signUpButton: {
//     backgroundColor: Colours.PRIMARY,
//     borderRadius: 10,
//     paddingVertical: height * 0.02,
//     alignItems: "center",
//     marginTop: height * 0.02,
//   },
//   signUpText: {
//     color: "white",
//     // fontSize: width * 0.04,
//     fontSize: dynamicFontSize(14),
//     fontFamily: "Sen-Bold",
//   },
//   logInView: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   loginText: {
//     color: Colours.DARKGRAY,
//     textAlign: "center",
//     // fontSize: width * 0.04,
//     fontSize: dynamicFontSize(14),
//     marginTop: height * 0.04,
//     fontFamily: "Sen-Regular",
//   },
//   loginLink: {
//     color: Colours.PRIMARY_LIGHT,
//     // fontSize: width * 0.04,
//     fontSize: dynamicFontSize(16),
//     marginTop: height * 0.04,
//     fontFamily: "Sen-Bold",
//   },
//   strengthMeter: {
//     // width: '80%',
//     height: dynamicSize(10),
//     backgroundColor: Colours.LIGHTGRAY,
//     marginTop: dynamicSize(10),
//     borderRadius: dynamicSize(10),
//     overflow: "hidden",
//   },
// });

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: dynamicSpacing(16),
    paddingTop: dynamicSpacing(40),
    backgroundColor: "white",
  },

  title: {
    fontSize: dynamicFontSize(30),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
    textAlign: "center",
    marginTop: dynamicSpacing(10),
  },

  profilePhotoContainer: {
    alignItems: "center",
    marginBottom: dynamicSpacing(16),
  },

  link: {
    textDecorationLine: "underline",
    color: Colours.PRIMARY_LIGHT,
    textAlign: "center",
    fontFamily: "Sen-Bold",
  },

  userImage: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(99),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    marginTop: dynamicSpacing(12),
  },

  addPhotoText: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
    marginTop: dynamicSpacing(4),
  },

  formContainer: {
    marginTop: dynamicSpacing(16),
  },

  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: dynamicSpacing(12),
  },

  inputBox: {
    width: "48%",
  },

  passwordErrorMsg: {
    padding: dynamicSize(10),
    marginTop: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    backgroundColor: Colours.PRIMARY_LIGHTER,
  },

  passwordMsgTxt: {
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    color: Colours.PRIMARY,
  },

  inputContainer: {
    marginBottom: dynamicSpacing(12),
  },

  label: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    marginBottom: dynamicSpacing(4),
  },

  birthDayTxt: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },

  birthDayEnteredTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },

  input: {
    height: dynamicSize(48),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    paddingHorizontal: dynamicSpacing(12),
  },

  birthdayBox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: dynamicSpacing(8),
    paddingVertical: dynamicSpacing(10),
  },

  shortInput: {
    height: dynamicSize(48),
    width: "100%",
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    paddingHorizontal: dynamicSpacing(12),
    justifyContent: "center",
  },

  signUpButton: {
    backgroundColor: Colours.PRIMARY,
    borderRadius: dynamicSize(10),
    paddingVertical: dynamicSpacing(14),
    alignItems: "center",
    marginTop: dynamicSpacing(16),
  },

  signUpText: {
    color: "white",
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
  },

  logInView: {
    alignItems: "center",
    justifyContent: "center",
  },

  loginText: {
    color: Colours.DARKGRAY,
    textAlign: "center",
    fontSize: dynamicFontSize(13),
    marginTop: dynamicSpacing(10),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicSize(20),
  },

  loginLink: {
    color: Colours.PRIMARY_LIGHT,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },

  strengthMeter: {
    height: dynamicSize(10),
    backgroundColor: Colours.LIGHTGRAY,
    marginTop: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    overflow: "hidden",
  },
});

export default BodySignUpScreen;
//real
